import script from "./NotificationBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationBanner.vue?vue&type=script&setup=true&lang=js"

import "./NotificationBanner.vue?vue&type=style&index=0&id=2c6b6517&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c6b6517"]])

export default __exports__